module.exports = __webpack_public_path__ + "img/rays_divider09.17942004.jpg";